import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "d-flex flex-column" }
const _hoisted_2 = { class: "overflow-auto hidden-scrollbar header-content" }
const _hoisted_3 = { class: "d-flex flex-row" }
const _hoisted_4 = { class: "header-content auth-buttons" }
const _hoisted_5 = { class: "header-content auth-buttons" }

import Welcome from "@/components/banners/Welcome.vue";
import {reactive} from "@vue/reactivity";
import BannerDTO from "@/models/BannerDTO";
import {api} from "@/service/APIClient";
import {onMounted} from "vue";
import { loadGoogleScript } from '@/composables/useGoogleSignIn'
import { loadFacebookScript } from '@/composables/useFacebookSignIn'
import { loadAppleScript } from '@/composables/useAppleSignIn'
import TokenOAuthRequestDTO from "@/models/request/TokenOAuthRequestDTO";
import {useStore} from "vuex";


export default /*@__PURE__*/_defineComponent({
  __name: 'Login',
  setup(__props) {

const state = reactive({
  banners: [] as BannerDTO[],
  googleClient: null as any
});

const store = useStore()

const loginWithApple = async () => {
  try {
    const data = await AppleID.auth.signIn()
    const idToken = data.authorization.id_token
    const token = await api.call.token.oauth({ type: 'APPLE', payload: idToken } as TokenOAuthRequestDTO)
    await store.dispatch('authenticate', token)
    window.location.href = '/'
  } catch (e) {
    // user closed the popup or error
  }
}

const loginWithFacebook = () => {
  window.FB.login((response:any) => {
    if (response.authResponse?.signedRequest) {
      api.call.token.oauth({ type: 'FACEBOOK', payload: response.authResponse.signedRequest } as TokenOAuthRequestDTO)
        .then(token => store.dispatch('authenticate', token))
        .then(() => { window.location.href = '/' })
    }
  }, { scope: 'public_profile,email' })
}

onMounted(async () => {
  await loadGoogleScript();
  state.googleClient = window.google.accounts.oauth2.initTokenClient({
    client_id: process.env.VUE_APP_GOOGLE_CLIENT_ID,
    scope: 'https://www.googleapis.com/auth/userinfo.email https://www.googleapis.com/auth/userinfo.profile',
    callback: async (response: any) => {
      const token = await api.call.token.oauth({type: 'GOOGLE', payload: response.access_token} as TokenOAuthRequestDTO)
      await store.dispatch('authenticate', token)
      window.location.href = '/';
    },
  });

  await loadFacebookScript(process.env.VUE_APP_FACEBOOK_APP_ID as string);
  await loadAppleScript(process.env.VUE_APP_APPLE_CLIENT_ID as string);

  [state.banners] = await Promise.all([
    api.call.banners.placement('login'),
  ])
})


return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).banners, (banner) => {
          return (_openBlock(), _createElementBlock(_Fragment, {
            key: banner.name
          }, [
            (banner.name ==='welcome')
              ? (_openBlock(), _createBlock(Welcome, {
                  key: 0,
                  config: banner.config
                }, null, 8, ["config"]))
              : _createCommentVNode("", true)
          ], 64))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => (_unref(state).googleClient.requestAccessToken()), ["prevent"])),
        class: "btn btn-secondary w-100 btn-auth"
      }, [
        _cache[3] || (_cache[3] = _createElementVNode("img", { src: "/img/google.svg" }, null, -1)),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('continue_with_google')), 1)
      ]),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (loginWithFacebook()), ["prevent"])),
        class: "btn btn-secondary w-100 btn-auth"
      }, [
        _cache[4] || (_cache[4] = _createElementVNode("img", { src: "/img/facebook.svg" }, null, -1)),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('continue_with_facebook')), 1)
      ]),
      _createElementVNode("button", {
        type: "button",
        onClick: _cache[2] || (_cache[2] = _withModifiers(($event: any) => (loginWithApple()), ["prevent"])),
        class: "btn btn-secondary w-100 btn-auth"
      }, [
        _cache[5] || (_cache[5] = _createElementVNode("img", { src: "/img/apple.svg" }, null, -1)),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('continue_with_apple')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_5, [
      _createVNode(_component_router_link, {
        to: {name:'emailLogin'},
        class: "btn btn-secondary w-100 btn-auth"
      }, {
        default: _withCtx(() => [
          _cache[6] || (_cache[6] = _createElementVNode("img", { src: "/img/email.svg" }, null, -1)),
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('continue_with_email')), 1)
        ]),
        _: 1,
        __: [6]
      })
    ])
  ]))
}
}

})